module.exports = __webpack_public_path__ + "static/media/3.130c0246.jpg";